import { useUnit } from 'effector-react'
import { useQuery } from 'react-query'

import { $creatorId } from '@/models/creators.ts'
import { NON_EXISTENT_USER_ID } from '@/modules/chatting/ui/chat-window/constants.tsx'

import { scriptsService } from '../service/service'

export const sentScriptIdsQueryKeyBase = 'sentScriptIds'

export const useSentScriptIdsByFanIdQuery = (fanId: number) => {
  const creatorId = useUnit($creatorId)

  return useQuery(
    [sentScriptIdsQueryKeyBase, creatorId, fanId],
    () => scriptsService.getSentScriptIdsByFanId(creatorId!, fanId),
    {
      enabled: !!creatorId && fanId !== NON_EXISTENT_USER_ID,
      placeholderData: [],
    },
  )
}
